module.exports = __webpack_public_path__ + "static/hero-f5a3f273756b93876d06bad38c00796d.jpg";